/* 🤖 this file was generated by svg-to-ts */
export const matIconBarChart: {
  name: 'bar-chart';
  data: string;
} = {
  name: 'bar-chart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 9h4v11H4zm12 4h4v7h-4zm-6-9h4v16h-4z"/></svg>`
};
